import { colors } from '@spaceshipapp/cambridge';
import React, { useMemo } from 'react';
import countryList from 'react-select-country-list';
import { CountrySelector } from './style';

interface selectorProps<T> {
  value?: string;
  onChange?(selectedItem: T): void;
}
const customStyles = {
  menu: (provided: any, state: any) => ({
    ...provided,

    color: state.selectProps.menuColor,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: `${colors.text}`,
    marginTop: 2,
    textAlign: 'left',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    width: '100%',
    color: `${colors.text}`,
    backgroundColor: state.isSelected ? '' : state.isFocused ? `${colors.border}` : '',
  }),
};

const CountrySelect = (props: selectorProps<any>): React.ReactElement => {
  const options = useMemo(() => countryList().getData(), []);
  const { onChange, value } = props;
  countryList().setLabel('TW', 'Taiwan');

  return (
    <>
      <CountrySelector
        styles={customStyles}
        id="country"
        value={value}
        placeholder="Select"
        options={options}
        onChange={onChange}
        theme={(theme: any) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: `${colors.border}`,
            primary: `${colors.border}`,
          },
        })}
      />
    </>
  );
};

export default CountrySelect;
